/**
 * MechaGuard - HUD (顶部状态栏)
 *
 * 管理生命值、金币、波次显示与「开始下一波」按钮。
 * 所有 setter 都做了值比对缓存：Game 每帧都会同步状态，
 * 无缓存会导致每帧都写 DOM，在低端设备上非常浪费。
 */

export class HUD {
  constructor() {
    this.lives = 10;
    this.gold = 200;
    this.currentWave = 0;
    this.totalWaves = 30;
    this.shield = 0;

    this._els = {};
    this._cache = {
      lives: null,
      gold: null,
      wave: null,
      prep: null,
      boss: null,
      shield: null,
      level: null,
    };
  }

  init() {
    this._els.lives = document.getElementById('lives-display');
    this._els.gold = document.getElementById('gold-display');
    this._els.wave = document.getElementById('wave-display');
    this._els.nextWaveBtn = document.getElementById('next-wave-btn');
    this._els.shield = document.getElementById('shield-display');
    this._els.shieldValue = document.getElementById('shield-value');
    this._els.level = document.getElementById('level-display');
  }

  /** 清空缓存，让下一轮同步强制写一次 DOM */
  reset() {
    this._cache.lives = null;
    this._cache.gold = null;
    this._cache.wave = null;
    this._cache.prep = null;
    this._cache.boss = null;
    this._cache.shield = null;
    this._cache.level = null;
  }

  /* ===================================================
   * 数值同步
   * =================================================== */

  setLives(lives) {
    if (lives === this._cache.lives) return;
    this._cache.lives = lives;
    this.lives = lives;

    const el = this._els.lives;
    if (!el) return;

    el.textContent = String(lives);
    el.classList.toggle('is-low', lives <= 3);
  }

  setGold(gold) {
    if (gold === this._cache.gold) return;
    this._cache.gold = gold;
    this.gold = gold;

    if (this._els.gold) this._els.gold.textContent = String(gold);
  }

  setWave(current, total) {
    const totalWaves = total || this.totalWaves;
    if (current === this._cache.wave && totalWaves === this.totalWaves) return;

    this._cache.wave = current;
    this.currentWave = current;
    this.totalWaves = totalWaves;

    if (this._els.wave) {
      this._els.wave.textContent = `${current} / ${totalWaves}`;
    }
  }

  /**
   * 更新「开始下一波」按钮
   * @param {number} seconds 剩余备战秒数；-1 表示正在作战（不可召唤）
   * @param {boolean} [nextIsBoss] 下一波是否 BOSS 波
   */
  setPrep(seconds, nextIsBoss = false) {
    const boss = !!nextIsBoss;
    if (seconds === this._cache.prep && boss === this._cache.boss) return;

    this._cache.prep = seconds;
    this._cache.boss = boss;

    const btn = this._els.nextWaveBtn;
    if (!btn) return;

    if (seconds < 0) {
      btn.disabled = true;
      btn.textContent = '作战中…';
      btn.classList.remove('is-boss');
    } else {
      btn.disabled = false;
      btn.textContent = boss ? `⚠ BOSS 波 (${seconds}s)` : `开始下一波 (${seconds}s)`;
      btn.classList.toggle('is-boss', boss);
    }
  }

  /**
   * 护盾点数（0 时隐藏）
   * @param {number} shield
   */
  setShield(shield) {
    if (shield === this._cache.shield) return;
    this._cache.shield = shield;
    this.shield = shield;

    const box = this._els.shield;
    if (!box) return;

    box.classList.toggle('hidden', shield <= 0);
    if (this._els.shieldValue) this._els.shieldValue.textContent = String(shield);
  }

  /** 关卡名 */
  setLevelName(name) {
    if (name === this._cache.level) return;
    this._cache.level = name;

    if (this._els.level) this._els.level.textContent = name || '';
  }
}
